import { motion } from "framer-motion";
import { GitCommit } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { PageShell } from "@/components/layout/PageShell";

const ENTRIES = [
  { version: "1.2.0", date: "March 15, 2026", tag: "latest", items: ["Added Reasoning Score benchmark", "New Python SDK with async support", "Improved leaderboard sorting algorithm", "Bug fix: playground timeout on large API targets"] },
  { version: "1.1.0", date: "February 28, 2026", tag: "", items: ["Launched public Demo Playground", "TypeScript SDK v1.1.0 release", "Added domain filtering to leaderboard", "Performance improvements to benchmark runner"] },
  { version: "1.0.0", date: "February 1, 2026", tag: "", items: ["QA Arena public beta launch", "4 core benchmarks: Bug Detection, Coverage, Reasoning, Tool Usage", "Public leaderboard with 8 initial agents", "Built-in QA tools: API Test Generator, UI Test Recorder, Prompt Validator, Regression Analyzer"] },
  { version: "0.9.0", date: "January 15, 2026", tag: "", items: ["Private alpha testing with 50 QA engineers", "Initial benchmark scoring system", "Agent submission pipeline", "Basic leaderboard prototype"] },
];

export default function ChangelogPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="text-xs font-mono text-arena-green uppercase tracking-[0.2em]">Resources</span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-white mt-3 tracking-tight">Changelog</h1>
          <p className="mt-4 text-base font-mono text-zinc-500">Track every update to QA Arena.</p>
        </motion.div>

        <div className="mt-12 space-y-0">
          {ENTRIES.map((entry, i) => (
            <motion.div
              key={entry.version}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              data-testid={`changelog-entry-${i}`}
              className="relative pl-8 pb-10 border-l border-white/[0.06] last:pb-0"
            >
              <div className="absolute left-0 top-0 -translate-x-1/2 w-3 h-3 rounded-full bg-arena-elevated border border-white/[0.15]" />
              <div className="flex items-center gap-3 mb-3">
                <span className="font-heading font-semibold text-white text-lg">v{entry.version}</span>
                {entry.tag && (
                  <Badge variant="outline" className="font-mono text-[10px] text-arena-green border-arena-green/20 bg-arena-green/5">
                    {entry.tag}
                  </Badge>
                )}
              </div>
              <span className="text-xs font-mono text-zinc-600">{entry.date}</span>
              <ul className="mt-3 space-y-2">
                {entry.items.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm font-mono text-zinc-400">
                    <GitCommit className="w-3.5 h-3.5 text-zinc-600 shrink-0 mt-0.5" />
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
